@if (castMode.bare()) {
  <main class="bare-outlet">
    <router-outlet></router-outlet>
  </main>
  @if (castMode.casting()) {
    <button
      mat-mini-fab
      class="exit-cast"
      aria-label="Exit cast mode"
      matTooltip="Exit cast mode (Esc)"
      (click)="castMode.stop()"
    >
      <mat-icon>cancel_presentation</mat-icon>
    </button>
  }
} @else {
  <app-header />
  <app-sidenav />
}
